export default __webpack_public_path__ + "static/media/ic-crops-kumera.49d84de7.svg";